<template>
    <div class="practice-profile mb-3 mt-page">

        <data-form
            :title="$i18n.gt('HEADING_EDIT_PRACTICE')"
            :save-button-label="$i18n.gt('LABEL_SAVE')"
            cancel-route="/"
            :field-model="practiceFields"
            :field-groups="fieldGroups"
            :load-model-instance="loadModelInstance"
            :on-submit-handler="onSubmit"
            :submit-success-message="$i18n.gt('LABEL_PRACTICE_UPDATED')"
            :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_PRACTICE')"
            submit-success-route="/">
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import PracticeFields from '@/models/Practice'

/**
 * Page for a Practitioner to edit their Practice profile
 */
export default Vue.extend({
    name: "PracticeProfile",
    props: {
        practiceId: Number
    },
    data() {
        return {
            practiceFields: PracticeFields,
            fieldGroups: [
                ["name", "npi", "practice_code_id"],
                ["address", "address2", "city", "state", "zip", "email", "website", "phone", "fax"],
                ["type", "comment", "use_dietid_questionnaire"],
            ],
        }
    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'practice', this.practiceId)

        },
        onSubmit(modelInstance) {
            return this.$api.updateItem(this, 'practice', modelInstance)
        }
    }
})

</script>

